export function RailLogo({ size = 44 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      role="img"
      aria-label="Order Manager"
    >
      <rect width="256" height="256" rx="48" fill="#1F1B16" />
      <rect x="20" y="40" width="14" height="176" rx="2" fill="#C96442" />
      <text
        x="142"
        y="178"
        textAnchor="middle"
        fontFamily="'Source Serif 4', Georgia, serif"
        fontWeight={600}
        fontSize={146}
        fill="#FBF9F5"
        letterSpacing={-5}
      >
        OM
      </text>
    </svg>
  );
}
